import styles from './index.module.less';
import { useState } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { useConfigProvider } from '@/context/ConfigProvider';

const Index: React.FC<any> = ({ advantage }) => {
  const { isMobile } = useConfigProvider();
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <div className={styles.container}>
      <div className={styles.block}></div>
      <div className={styles.content}>
        <h2 className={styles.title}>{advantage.title}</h2>
        <div className={styles.desc}>{advantage.desc}</div>
        <ul className={styles.list}>
          {advantage?.cards?.map((item: any, index: number) => (
            <li
              key={item.title}
              style={{ backgroundImage: `url(${item.imgPath})` }}
              onClick={() => setActiveIndex(index)}
            >
              <div>
                <div>
                  <div>{index + 1}</div>
                  <div
                    className={styles.mobileTitle}
                    style={{
                      display: activeIndex == index ? 'none' : 'block',
                    }}
                  >
                    {item.title}
                  </div>
                </div>
                <div
                  className={styles.mobileIcon}
                  style={{
                    display: activeIndex === index ? 'none' : 'flex',
                  }}
                >
                  <DownOutlined />
                </div>
              </div>
              <div
                className={styles.desktopTitle}
                style={{
                  display: activeIndex === index ? 'block' : 'none',
                }}
              >
                {item.title}
              </div>
              <div
                className={styles.desktopDesc}
                style={{
                  display: activeIndex === index ? 'block' : 'none',
                }}
              >
                {item.desc}
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.bottom}>{advantage.anouncement}</div>
    </div>
  );
};

export default Index;
